module.exports = __webpack_public_path__ + "static/media/discover.9fa18c90.png";